import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

// Set BootstrapVue globally.
import BootstrapVue from "bootstrap-vue";
import "./css/bootstrap-overrides.scss";
import "bootstrap-vue/dist/bootstrap-vue.css";
Vue.use(BootstrapVue);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
